<div class="container">
  <h1 class="display-5 fw-semibold mb-4">
    {{ params.type !== 'licenciaturas' ? 'Nuestros' : 'Nuestras' }}
    {{ params.type }}
  </h1>

  <div class="row mb-4 align-items-end gy-2">
    <div class="col-md-6 d-flex">
      <div>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" placeholder="Buscar" />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <select class="form-select">
        <option value="" selected disabled hidden>Ordenar por</option>
        <option value="recent">Más reciente</option>
        <option value="oldest">Más antiguo</option>
      </select>
    </div>
    <div class="col-md-3">
      <input type="date" class="form-control" />
    </div>
  </div>

  <hr />

  @for (program of programs; track program.id) {
    <div class="d-flex justify-content-between mb-3">
      <div class="d-flex">
        <i class="bi bi-play-fill me-1"></i>

        <a [routerLink]="['/programas', params.type, program.id]">
          <span>{{ program.name }}</span>
          <br />
          <span class="text-body-tertiary">{{ program.description }}</span>
        </a>
      </div>

      <div class="d-flex gap-2">
        <p class="text-nowrap">Fecha de inicio:</p>
        <i class="bi bi-calendar-week-fill me-1"></i>
        {{ program.date | date: 'dd/MM/yy' }}
      </div>
    </div>
  } @empty {
    @if (loading) {
      @for (placeholder of [1, 2, 3, 4, 5]; track placeholder) {
        <div class="container placeholder-glow">
          <div class="row justify-content-between">
            <span class="placeholder col-3"></span>
            <span class="placeholder col-2"></span>
          </div>
        </div>
        <div class="placeholder-glow mb-4">
          <span class="placeholder col-7"></span>
        </div>
      }
    }
  }
</div>
